/* ========================================================================== *
 * ENVIRONMENT VARIABLES                                                      *
 * -------------------------------------------------------------------------- *
 * Normalize and export environment variables from ".env...." files.          *
 * ========================================================================== */
export const env = import.meta.env
